import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { MODEL_NAMES } from './constants/modelNames';

// English translations
const en = {
  translation: {
    chat: {
      title: 'Chat',
      uploadFiles: 'Upload files',
      selectModel: 'Select model',
      selectIndustry: 'Select industry',
      chatPlaceholder: 'Drag in files or type to start chatting',
      recentConversations: 'Recent Conversations',
      quickActions: 'Quick Actions',
      settings: 'Settings & Help',
      profile: 'Profile',
      upgradePlan: 'Upgrade Plan',
      poweredBy: 'Powered by Karbon Digital',
    },
    chatPanel: {
      placeholder: "Ask Docufy anything you'd like",
      search: 'Search',
      reason: 'Reason',
      promptIdeas: 'Prompt ideas',
      languageTranslation: 'Language Translation: {{language}}',
    },
    models: {
      gpt4: 'GPT-4',
      gpt35: 'GPT-3.5',
      claude2: 'Claude 2',
      claude3: 'Claude 3',
      gemini: MODEL_NAMES.GEMINI,
      llama: 'Llama 2',
    },
    industries: {
      legal: 'Legal & Judiciary',
      'banking-financial-services': 'Banking & Financial Services',
      accounting: 'banking-financial-services', // Legacy support
      healthcare: 'Healthcare & Life Sciences',
      insurance: 'Insurance Services',
      retail: 'Retail & Supply Chain',
    },
  },
};

// Add more languages here as needed
const resources = {
  en: en,
  // Add more languages here, e.g.:
  // es: { translation: { ... } },
  // fr: { translation: { ... } }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
